/** Values stored on leads.source when creating/editing from the CRM form. */
export const LEAD_SOURCE_OPTIONS = [
  'Facebook',
  'LinkedIn',
  'Instagram',
  'Website',
  'Landing Page',
  'Google',
  'WhatsApp',
  'Referral',
  'Others',
];

/** Analytics / list filter groups (must match backend sourceGroups.DISPLAY_ORDER). */
export const LEAD_SOURCE_FILTER_GROUPS = [
  'Facebook',
  'Google',
  'Instagram',
  'WhatsApp',
  'Website',
  'Landing Page',
  'Referral',
  'Other',
];
